<template>
    <div id="messageList">
        <div msg-head>
            <el-radio-group v-model="queryParams.group" border @change="changeTab">
                <el-badge is-dot :hidden="tabSysCnt<=0" :value="tabSysCnt" class="item">
                    <el-radio-button label="系统消息"></el-radio-button>
                </el-badge>
                <el-badge is-dot :hidden="tabElCnt<=0" :value="tabElCnt" class="item">
                    <el-radio-button label="电子资料"></el-radio-button>
                </el-badge>
                <el-badge is-dot :hidden="tabBakCnt<=0" :value="tabBakCnt" class="item">
                    <el-radio-button label="缺货反馈"></el-radio-button>
                </el-badge>
            </el-radio-group>
        </div>
        <div msg-list v-loading="loading">
            <scroller ref="myscroller" :on-refresh="refresh" :on-infinite="infinite" noDataText="没有更多信息了">
                <div msg-list-item v-for="m in msgList" @click="goDetail(m)">
                    <div msg-item-date>{{m.CreateTime}}</div>
                    <div msg-title>
                        <i read-marker v-if="!m.IsRead" class="fa fa-circle" aria-hidden="true"></i>{{m.Title}}</div>
                    <div msg-desc>
                        <div msg-desc-left v-if="m.IconId>0">
                            <img msg-desc-left-pic :src="baseUrl+'/File/PreView/'+m.IconId">
                        </div>
                        <div msg-desc-right>{{m.Descreiption}}</div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import { getMessageList, imgServerHost, getMessageDetail } from "../../api/api";
    import store from "../../utils/storage";

    export default {
        name: "Login",
        data() {
            return {
                loading: false,
                msgList: [],
                baseUrl: imgServerHost(),
                tabSysCnt: 0,
                tabElCnt: 0,
                tabBakCnt: 0,
                queryParams: {
                    pageSize: 20,
                    page: 1,
                    uid: this.$route.params.uid,
                    group: '系统消息',
                }
            };
        },
        mounted() {
            var curTab = store.getStore('cur-msg-tab');
            if(curTab) this.queryParams.group = curTab;
            else store.setStore('cur-msg-tab','系统消息');
            
            this.getMessageList(null, false);
        },
        methods: {
            getMessageList(done, isadd) {
                this.queryParams.group = decodeURIComponent(this.queryParams.group);
                getMessageList(this.queryParams).then(res => {
                    if (done) done();
                    if (res.data.Code != 1) return;
                    if (res.data.Data.length == 0) {
                        this.$refs.myscroller.finishInfinite(true);
                    }

                    var extCnts = res.data.ExtData.split('|');
                    this.tabSysCnt = parseInt(extCnts[0]);
                    this.tabElCnt = parseInt(extCnts[1]);
                    this.tabBakCnt = parseInt(extCnts[2]);

                    if (isadd == true)
                        res.data.Data.forEach(element => this.msgList.push(element));
                    else
                        this.msgList = res.data.Data;
                });
            },
            changeTab() {
                this.queryParams.page = 1;
                store.setStore('cur-msg-tab', this.queryParams.group);

                // var href = decodeURIComponent(window.location.href);
                // href = href.replace('系统消息', '');
                // href = href.replace('电子资料', '');
                // href = href.replace('缺货反馈', '');
                // href = href + this.queryParams.group;
                // window.location.href = href;
                this.getMessageList(null, false);
            },
            goDetail(m) {
                getMessageDetail({ pid: m.SysMessageId, uid: this.$route.params.uid }).then(res => { });
                m.IsRead = true;

                // if (m.GroupType == '系统消息')
                //     this.tabSysCnt--;
                // if (m.GroupType == '电子资料')
                //     this.tabElCnt--;
                // if (m.GroupType == '缺货反馈')
                //     this.tabBakCnt--;

                if (m.PageUrl != '' && m.PageUrl != null)
                    window.location.href = m.PageUrl;
                else if (m.GroupType == '缺货反馈')
                    this.$router.push('/messagebackdetil/' + m.QiNiuKey + '/' + this.$route.params.uid + '/' + m.SysMessageId );
                else
                    this.$router.push('/messagedetil/' + m.SysMessageId + '/' + this.$route.params.uid );
            },
            refresh(done) {
                setTimeout(() => {
                    this.queryParams.page = 1;
                    this.getMessageList(done, false);
                }, 1000);

            },
            infinite(done) {
                setTimeout(() => {
                    this.queryParams.page += 1;
                    this.getMessageList(done, true);
                }, 1000);
            }
        }
    }
</script>


<style scoped>
    @import "../../assets/css/infoData/messagelist.css";
</style>


// WEBPACK FOOTER //
// src/components/infoData/MessageList.vue